<template>
    <div>
        <div class='footer-column-title'>
            SERVICES
        </div>
        <div class='footer-column-links'>
            <div @click="onClickLink('wine-club/delivery')"><a class="footer-link">Delivery</a></div>
            <div @click="onClickLink('wine-club/drink-responsibly')"><a class="footer-link">Drink Responsibly</a></div>
            <div @click="onClickLink('wine-club/privacy-cookies')"><a class="footer-link">Privacy &amp; Cookies</a></div>
            <div @click="onClickLink('wine-club/faqs')"><a class="footer-link">FAQs</a></div>
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        onClickLink(page) {
            this.$router.push(`/${page}`);
        }
    }
}
</script>
